
import moment from "moment";
export default [
  {
    name: "createdOn",
    title: 'Date',
    width: "10%",
    sortField: "createdOn",
    formatter(value) {
      if (value) {
        return moment(new Date(value)).utc().format("YYYY-MM-DD");
      }
    }
  },
  {
    name: "client",
    title: 'Client',
    width: "30%",
    sortField: "client.name",
    formatter(value) {
      if (value) {
        return value.name;
      }else{
        return "N/A";
      }
    }
  },
  {
    name: "custom-description",
    title: 'Description',
    width: "40%",
    sortField: "description"
  }
]